import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {map, switchMap, tap} from "rxjs/operators";
import {Observable, of} from "rxjs";
import {
  GroupTeacherCreateComponent
} from "../../../components/groups/group-participant-create/group-teacher-create.component";
import {
  GroupStudentCreateComponent
} from "../../../components/groups/group-participant-create/group-student-create.component";
import {GroupV3RestService} from "../../../services/rest/v3/group-rest.service";
import {Group, GroupDetails, GroupRef, MemberRole, V3GroupStudent, V3GroupTeacher} from "../../../model/v3/schools";
import {Page, Pageable} from "../../../model/rest/base";

@Component({
    selector: 'app-group-edit-page',
    templateUrl: './group-edit-page.component.html',
    styleUrls: ['./group-edit-page.component.scss'],
    standalone: false
})
export class GroupEditPageComponent implements OnInit {
  schoolId: number;
  groupDetails = {} as GroupDetails
  isLoading = false
  groupId: number = null
  group: Group
  groupStudents: Page<V3GroupStudent>
  groupTeachers: Page<V3GroupTeacher>
  studentPageable = new Pageable(0, 2, null)
  teacherPageable = new Pageable(0, 2, null)
  @ViewChild('groupTeacherCreate') groupTeacherCreate: GroupTeacherCreateComponent
  @ViewChild('groupStudentCreate') groupStudentCreate: GroupStudentCreateComponent

  constructor(activatedRoute: ActivatedRoute,
              private groupV3Rest: GroupV3RestService,
              private router: Router) {
    activatedRoute.paramMap.pipe(
      map( params => {
        this.schoolId = Number(params.get('schoolId'))
        this.groupId = Number(params.get('groupId'))
      }),
      switchMap(_ => this.loadGroupDetails())
    ).subscribe();
  }

  ngOnInit(): void {
  }

  addTeacher() {
    this.groupTeacherCreate.addParticipant();
    this.loadGroupDetails().subscribe()
  }
  addStudent() {
    this.groupStudentCreate.addParticipant();
    this.loadGroupDetails().subscribe()
  }

  loadGroupDetails() {
    if (!this.groupId)
      return of(null)

    return this.groupV3Rest.getGroup(this.schoolId, this.groupId).pipe(
      tap(group => {
        this.group = group
        this.groupDetails.name = group.name
      }),
      switchMap(_ => this.loadStudents(this.studentPageable)),
      switchMap(_ => this.loadTeachers(this.teacherPageable))
    )
  }

  loadStudents(pageable: Pageable) {
    return this.groupV3Rest.getGroupMembers(this.schoolId, this.groupId, pageable, MemberRole.Student).pipe(
      tap(groupStudents => this.groupStudents = groupStudents as Page<V3GroupStudent>),
    )
  }

  loadTeachers(pageable: Pageable) {
    return this.groupV3Rest.getGroupMembers(this.schoolId, this.groupId, pageable, MemberRole.Teacher).pipe(
      tap(groupTeachers => this.groupTeachers = groupTeachers as Page<V3GroupTeacher>),
    )
  }

  onGroupNameSave() {
    this.isLoading = true
    let observable: Observable<any>

    if(!this.groupId)
      observable = this.groupV3Rest.createNewGroup(this.schoolId, this.groupDetails).pipe(
        tap((groupRef: GroupRef) => this.groupId = groupRef.id),
        tap(_ => this.router.navigate(['school', this.schoolId, 'v2_groups','group', this.groupId, 'edit']))
      )
    else
      observable = this.groupV3Rest.updateGroup(this.schoolId, this.groupId, this.groupDetails)

    observable.pipe(
      switchMap(_ => this.loadGroupDetails())
    ).subscribe(_ => {
      this.isLoading = false
    })
  }

  getGroupName() {
    return this.groupDetails?.name
  }

  deleteParticipant(parti: V3GroupTeacher | V3GroupStudent) {
    this.groupV3Rest.deleteMember(this.schoolId, this.groupId, parti.id).pipe(
      switchMap(_ => this.loadGroupDetails())
    ).subscribe()
  }

  editTeacher(parti: V3GroupTeacher) {
    this.groupTeacherCreate.prepareParticipantEdition(parti)
  }

  editStudent(parti: V3GroupStudent) {
    this.groupStudentCreate.prepareParticipantEdition(parti)
  }
}
